import './ZonesIntervention.css';

const zones = [
  { city: 'Rabat', desc: 'Siège social et showroom. Interventions dans tout l\'agglomération (Hay Riad, Souissi, Agdal).' },
  { city: 'Casablanca', desc: 'Projets résidentiels de luxe (Anfa, Bouskoura) et aménagements de bureaux.' },
  { city: 'Marrakech', desc: 'Expertise spécifique pour les villas de prestige et riads de la ville ocre.' },
  { city: 'Tanger', desc: 'Accompagnement des grands projets immobiliers et hôteliers du Nord.' }
];

export default function ZonesIntervention() {
  return (
    <section className="zones-section">
      <div className="container">
        <div className="zones-grid">
          <div className="zones-info" data-aos="fade-right">
            <span className="section-label">Proximité & Réactivité</span>
            <h2 className="section-title">
              NOS ZONES<br />
              <em>D'INTERVENTION.</em>
            </h2>
            <p className="section-subtitle">
              Basés à Rabat, nous déployons nos équipes d'artisans menuisiers qualifiés 
              à travers tout le Maroc pour vos projets d'exception.
            </p>
          </div>
          
          <div className="zones-list">
            {zones.map((zone, idx) => (
              <div 
                key={zone.city} 
                className="zone-card" 
                data-aos="fade-up" 
                data-aos-delay={idx * 100}
              >
                <div className="zone-card__header">
                  <span className="zone-card__dot"></span>
                  <h3 className="zone-card__city">{zone.city}</h3>
                </div>
                <p className="zone-card__desc">{zone.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
